import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LayoutGrid, Settings, LogOut } from "lucide-react";

export function AdminLayout({ children }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, signOut } = useAuth();
  const items = [
    { to: "/admin", label: "Jobs", icon: LayoutGrid, testid: "nav-jobs" },
    ...(user?.role === "admin" ? [{ to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-settings" }] : []),
  ];
  return (
    <div className="min-h-screen flex">
      <aside className="w-16 md:w-64 bg-[#F3F4F6] border-r border-slate-200 flex flex-col shrink-0">
        <div className="h-16 flex items-center px-4 md:px-6 border-b border-slate-200">
          <div className="hidden md:block"><Logo to="/admin" /></div>
          <a href="/admin" className="md:hidden mx-auto" data-testid="logo-mark-mobile">
            <img src="https://customer-assets-lqy194kg.emergentagent.net/job_jobprint-system/artifacts/yg85cspu_PngMarkColorCroppedSmall.webp" alt="Borrow A Geek" className="h-8 w-8 object-contain" />
          </a>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {items.map((it) => {
            const active = loc.pathname === it.to;
            return (
              <Link key={it.to} to={it.to} data-testid={it.testid}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg font-semibold text-sm transition-colors ${
                  active ? "bg-ink text-white" : "text-slate-600 hover:bg-slate-200"
                }`}>
                <it.icon size={18} /><span className="hidden md:inline">{it.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <div className="hidden md:block px-3 py-1 text-xs text-slate-500 truncate">{user?.email}</div>
          <button onClick={() => { signOut(); nav("/admin/login"); }} data-testid="admin-logout"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg font-semibold text-sm text-slate-600 hover:bg-slate-200 w-full transition-colors">
            <LogOut size={18} /><span className="hidden md:inline">Sign out</span>
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0 bg-[#F9FAFB]">{children}</div>
    </div>
  );
}
